export default function(slidePoints, currentSlide) {
    if (!slidePoints[currentSlide]) {
        return;
    }

    let svgPath = '', points = [];

    // Retrieve bounding rectangle for the current slide
    let svgPathRect = document.getElementsByClassName('slide')[currentSlide].getBoundingClientRect();
    
    // Get the positions of all the slide points
    for (let i = 0; i < slidePoints[currentSlide].length; i++) {
        let element = slidePoints[currentSlide][i].getBoundingClientRect();
        let x = element.left + element.width / 2.0 - svgPathRect.left;
        let y = element.top + element.height / 2.0 - svgPathRect.top;
        points.push([x, y]);
    }

    // Function to calculate control points to form smoother curves
    const getCircularControlPointOutward = (p1, p2, circularityFactor = 0.9) => {
        let dx = p2[0] - p1[0];
        let dy = p2[1] - p1[1];
        // let distance = Math.sqrt(dx * dx + dy * dy);

        // Midpoint between p1 and p2
        let midX = (p1[0] + p2[0]) / 2;
        let midY = (p1[1] + p2[1]) / 2;

        // Perpendicular offset from the midpoint for circularity (adjust this factor for roundness)
        // Flip the offset direction by reversing the signs of the perpendicular offsets
        let offsetX = dy * circularityFactor;
        let offsetY = -dx * circularityFactor;

        return [midX + offsetX, midY + offsetY];
    };

    // Start drawing the path from the first point
    let pIndex = 0;
    svgPath = `M ${points[pIndex][0]} ${points[pIndex][1]}`;

    // Loop through the points to create quadratic curves between them
    for (pIndex = 1; pIndex < points.length; pIndex++) {
        let [controlX, controlY] = getCircularControlPointOutward(points[pIndex - 1], points[pIndex]);
        svgPath += ` Q ${controlX} ${controlY} ${points[pIndex][0]} ${points[pIndex][1]}`;
    }

    // Close the path with a smooth curve to the starting point
    let [closeControlX, closeControlY] = getCircularControlPointOutward(points[points.length - 1], points[0]);
    svgPath += ` Q ${closeControlX} ${closeControlY} ${points[0][0]} ${points[0][1]}`;

    return svgPath;
}
